import React from 'react';

import ergeonLogo from '@ergeon/core-components/src/assets/ergeon-logo-blue.svg';

const Logo: React.FC = () => {
  return (
    <div className="flex justify-start items-center shrink-0">
      <img alt="Ergeon Logo" className="px-3 w-40 max-w-none object-left" src={ergeonLogo} />
    </div>
  );
};

export default Logo;
